module.exports = __webpack_public_path__ + "img/page-ico.30a9ac8f.png";